/* eslint import/no-extraneous-dependencies: off */
import { createSlice } from '@reduxjs/toolkit';
import history from '@history';
import _ from '@lodash';
import { setInitialSettings } from 'app/store/fuse/settingsSlice';
import { showMessage } from 'app/store/fuse/messageSlice';
import jwtService from 'app/services/jwtService';
import queryClient from 'app/queryClient';

export const setUserData = (user) => async (dispatch) => {
  /*
  Set User Settings
  */
  // dispatch(setDefaultSettings(user.data.settings));
  dispatch(setUser(user));
};

export const updateUserSettings = (settings) => async (dispatch, getState) => {
  const oldUser = getState().auth.user;
  const user = _.merge({}, oldUser, { data: { settings } });

  dispatch(updateUserData(user));

  return dispatch(setUserData(user));
};

export const updateUserShortcuts = (shortcuts) => async (dispatch, getState) => {
  const { user } = getState().auth;
  const newUser = {
    ...user,
    data: {
      ...user.data,
      shortcuts,
    },
  };

  dispatch(updateUserData(newUser));

  return dispatch(setUserData(newUser));
};

let logoutInProgress = false;

export const logoutUser = () => async (dispatch, getState) => {
  const { user } = getState().auth;

  if (!user.roles || user.roles.length === 0) {
    // is guest
    return;
  }

  // Guard against re-entry: revokeSession() can hit a 401 that emits onAutoLogout,
  // which dispatches logoutUser() again while the first call is still in flight.
  if (logoutInProgress) return;
  logoutInProgress = true;

  try {
    // Revoke server-side before clearing local storage — the revoke needs the access token.
    await jwtService.revokeSession();
    jwtService.clearSession();

    queryClient.cancelQueries();
    queryClient.clear();

    dispatch(setInitialSettings());
    dispatch(userLoggedOut());

    history.push({ pathname: '/login' });
  } finally {
    logoutInProgress = false;
  }
};

export const updateUserData = (user) => async (dispatch) => {
  if (!user.roles || user.roles.length === 0) {
    // is guest
    return;
  }

  jwtService
    .updateUserData(user)
    .then(() => {
      dispatch(showMessage({ message: 'User data saved with api' }));
    })
    .catch((error) => {
      dispatch(showMessage({ message: error.message }));
    });
};

const initialState = {
  roles: [], // guest
  forename: 'John',
  surname: 'Doe',
  photoUrl: 'assets/images/avatars/Velazquez.jpg',
  username: 'johndoe@healthera.co.uk',
  guest: true,
};

const userSlice = createSlice({
  name: 'auth/user',
  initialState,
  reducers: {
    setUser: (state, action) => ({ ...action.payload, guest: false }),
    userLoggedOut: () => initialState,
  },
  extraReducers: {},
});

export const { setUser, userLoggedOut } = userSlice.actions;

export default userSlice.reducer;
